import { render, staticRenderFns } from "./GradesInquiries.vue?vue&type=template&id=d394e43e&scoped=true&"
import script from "./GradesInquiries.vue?vue&type=script&lang=js&"
export * from "./GradesInquiries.vue?vue&type=script&lang=js&"
import style0 from "./GradesInquiries.vue?vue&type=style&index=0&id=d394e43e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d394e43e",
  null
  
)

export default component.exports